module.exports = __webpack_public_path__ + "img/view_media_default.b988b969.png";